import { render, staticRenderFns } from "./list.vue?vue&type=template&id=4a63eba4&scoped=true"
import script from "./list.vue?vue&type=script&lang=ts"
export * from "./list.vue?vue&type=script&lang=ts"
import style0 from "./list.vue?vue&type=style&index=0&id=4a63eba4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a63eba4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a63eba4')) {
      api.createRecord('4a63eba4', component.options)
    } else {
      api.reload('4a63eba4', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=4a63eba4&scoped=true", function () {
      api.rerender('4a63eba4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/policies-discounts/list.vue"
export default component.exports